<div class="w-full">
  <h1 class="mat-display-1 qaroni-title my-4 text-center">
    <ng-content />
  </h1>
</div>
